module.exports = __webpack_public_path__ + "fonts/MaterialIcons-Regular.8ef52a15.ttf";